import * as ambassadorWixTableReservationsV1Experience from './table-reservations-v1-experience-experiences.http.js';
import * as ambassadorWixTableReservationsV1ExperienceTypes from './table-reservations-v1-experience-experiences.types.js';
import * as ambassadorWixTableReservationsV1ExperienceUniversalTypes from './table-reservations-v1-experience-experiences.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createExperience(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.CreateExperienceRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.CreateExperienceRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.CreateExperienceResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.CreateExperienceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.createExperience(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/experiences',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getExperience(): __PublicMethodMetaInfo<
  'GET',
  { experienceId: string },
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.GetExperienceRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.GetExperienceRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.GetExperienceResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.GetExperienceResponse
> {
  const payload = { experienceId: ':experienceId' } as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.getExperience(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/experiences/{experienceId}',
    pathParams: { experienceId: 'experienceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getExperienceBySlug(): __PublicMethodMetaInfo<
  'GET',
  { slug: string },
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.GetExperienceBySlugRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.GetExperienceBySlugRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.GetExperienceBySlugResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.GetExperienceBySlugResponse
> {
  const payload = { slug: ':slug' } as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.getExperienceBySlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/experiences/slug/{slug}',
    pathParams: { slug: 'slug' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExperience(): __PublicMethodMetaInfo<
  'PATCH',
  { experienceId: string },
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.UpdateExperienceRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.UpdateExperienceRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.UpdateExperienceResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.UpdateExperienceResponse
> {
  const payload = { experience: { id: ':experienceId' } } as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.updateExperience(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/experiences/{experience.id}',
    pathParams: { experienceId: 'experienceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryExperiences(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.QueryExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.QueryExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.QueryExperiencesResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.QueryExperiencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.queryExperiences(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/experiences/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchExperiences(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.SearchExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.SearchExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.SearchExperiencesResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.SearchExperiencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.searchExperiences(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/experiences/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateExperiences(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkUpdateExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkUpdateExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkUpdateExperiencesResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkUpdateExperiencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.bulkUpdateExperiences(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/experiences/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateExperienceTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkUpdateExperienceTagsRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkUpdateExperienceTagsRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkUpdateExperienceTagsResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkUpdateExperienceTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.bulkUpdateExperienceTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/experiences/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateExperienceTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkUpdateExperienceTagsByFilterRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkUpdateExperienceTagsByFilterRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkUpdateExperienceTagsByFilterResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkUpdateExperienceTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.bulkUpdateExperienceTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/experiences/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkArchiveExperiences(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkArchiveExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkArchiveExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkArchiveExperiencesResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkArchiveExperiencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.bulkArchiveExperiences(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/experiences/archive',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUnarchiveExperiences(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkUnarchiveExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkUnarchiveExperiencesRequest,
  ambassadorWixTableReservationsV1ExperienceUniversalTypes.BulkUnarchiveExperiencesResponse,
  ambassadorWixTableReservationsV1ExperienceTypes.BulkUnarchiveExperiencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixTableReservationsV1Experience.bulkUnarchiveExperiences(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/experiences/unarchive',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Experience as ExperienceOriginal,
  Table as TableOriginal,
  TableCombination as TableCombinationOriginal,
  TableAvailabilityType as TableAvailabilityTypeOriginal,
  TableAvailabilityTypeWithLiterals as TableAvailabilityTypeWithLiteralsOriginal,
  TableAssignmentType as TableAssignmentTypeOriginal,
  TableAssignmentTypeWithLiterals as TableAssignmentTypeWithLiteralsOriginal,
  SpecificTablesOptions as SpecificTablesOptionsOriginal,
  TableManagementMode as TableManagementModeOriginal,
  TableManagementModeWithLiterals as TableManagementModeWithLiteralsOriginal,
  OnOptions as OnOptionsOriginal,
  OnOptionsOptionsOneOf as OnOptionsOptionsOneOfOriginal,
  Unit as UnitOriginal,
  UnitWithLiterals as UnitWithLiteralsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  StartDaysAndTimesDayOfWeek as StartDaysAndTimesDayOfWeekOriginal,
  StartDaysAndTimesDayOfWeekWithLiterals as StartDaysAndTimesDayOfWeekWithLiteralsOriginal,
  StartDaysAndTimes as StartDaysAndTimesOriginal,
  Recurrence as RecurrenceOriginal,
  RecurrenceWithLiterals as RecurrenceWithLiteralsOriginal,
  WeeklyOptions as WeeklyOptionsOriginal,
  OneTimeOptions as OneTimeOptionsOriginal,
  Entry as EntryOriginal,
  EntryRecurrenceOptionsOneOf as EntryRecurrenceOptionsOneOfOriginal,
  PartySize as PartySizeOriginal,
  NoticePeriod as NoticePeriodOriginal,
  Approval as ApprovalOriginal,
  MaxGuests as MaxGuestsOriginal,
  OnlineReservationsBusinessSchedule as OnlineReservationsBusinessScheduleOriginal,
  PageUrlV2 as PageUrlV2Original,
  PrivacyPolicy as PrivacyPolicyOriginal,
  PrivacyPolicyValueOneOf as PrivacyPolicyValueOneOfOriginal,
  TermsAndConditions as TermsAndConditionsOriginal,
  TermsAndConditionsValueOneOf as TermsAndConditionsValueOneOfOriginal,
  CustomFieldDefinition as CustomFieldDefinitionOriginal,
  EmailMarketingCheckbox as EmailMarketingCheckboxOriginal,
  CommonImage as CommonImageOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  Image as ImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  SketchData as SketchDataOriginal,
  Variant as VariantOriginal,
  VariantWithLiterals as VariantWithLiteralsOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  BannerPosition as BannerPositionOriginal,
  BannerPositionWithLiterals as BannerPositionWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  CheckboxListData as CheckboxListDataOriginal,
  ListItemNodeData as ListItemNodeDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  PaymentPolicyType as PaymentPolicyTypeOriginal,
  PaymentPolicyTypeWithLiterals as PaymentPolicyTypeWithLiteralsOriginal,
  PerGuestOptions as PerGuestOptionsOriginal,
  DisplayInfo as DisplayInfoOriginal,
  PaymentPolicy as PaymentPolicyOriginal,
  PaymentPolicyOptionsOneOf as PaymentPolicyOptionsOneOfOriginal,
  OnlineReservations as OnlineReservationsOriginal,
  ReservationForm as ReservationFormOriginal,
  TableManagement as TableManagementOriginal,
  TableManagementOptionsOneOf as TableManagementOptionsOneOfOriginal,
  Configuration as ConfigurationOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  SeoSettings as SeoSettingsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  TagsModified as TagsModifiedOriginal,
  CreateExperienceRequest as CreateExperienceRequestOriginal,
  CreateExperienceResponse as CreateExperienceResponseOriginal,
  GetExperienceRequest as GetExperienceRequestOriginal,
  GetExperienceResponse as GetExperienceResponseOriginal,
  GetExperienceBySlugRequest as GetExperienceBySlugRequestOriginal,
  GetExperienceBySlugResponse as GetExperienceBySlugResponseOriginal,
  UpdateExperienceRequest as UpdateExperienceRequestOriginal,
  UpdateExperienceResponse as UpdateExperienceResponseOriginal,
  QueryExperiencesRequest as QueryExperiencesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryExperiencesResponse as QueryExperiencesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  SearchExperiencesRequest as SearchExperiencesRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  SearchDetailsMode as SearchDetailsModeOriginal,
  SearchDetailsModeWithLiterals as SearchDetailsModeWithLiteralsOriginal,
  SearchExperiencesResponse as SearchExperiencesResponseOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  BulkUpdateExperiencesRequest as BulkUpdateExperiencesRequestOriginal,
  MaskedExperience as MaskedExperienceOriginal,
  BulkUpdateExperiencesResponse as BulkUpdateExperiencesResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateExperiencesResult as BulkUpdateExperiencesResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateExperienceTagsRequest as BulkUpdateExperienceTagsRequestOriginal,
  BulkUpdateExperienceTagsResponse as BulkUpdateExperienceTagsResponseOriginal,
  BulkUpdateExperienceTagsResult as BulkUpdateExperienceTagsResultOriginal,
  BulkUpdateExperienceTagsByFilterRequest as BulkUpdateExperienceTagsByFilterRequestOriginal,
  BulkUpdateExperienceTagsByFilterResponse as BulkUpdateExperienceTagsByFilterResponseOriginal,
  BulkArchiveExperiencesRequest as BulkArchiveExperiencesRequestOriginal,
  BulkArchiveExperiencesResponse as BulkArchiveExperiencesResponseOriginal,
  BulkArchiveExperiencesResult as BulkArchiveExperiencesResultOriginal,
  BulkUnarchiveExperiencesRequest as BulkUnarchiveExperiencesRequestOriginal,
  BulkUnarchiveExperiencesResponse as BulkUnarchiveExperiencesResponseOriginal,
  BulkUnarchiveExperiencesResult as BulkUnarchiveExperiencesResultOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateExperienceApplicationErrors as UpdateExperienceApplicationErrorsOriginal,
  BulkUpdateExperiencesApplicationErrors as BulkUpdateExperiencesApplicationErrorsOriginal,
  BulkUpdateExperienceTagsApplicationErrors as BulkUpdateExperienceTagsApplicationErrorsOriginal,
  BulkUpdateExperienceTagsByFilterApplicationErrors as BulkUpdateExperienceTagsByFilterApplicationErrorsOriginal,
} from './table-reservations-v1-experience-experiences.types.js';
